import { render } from "./AntiEmailPage.vue?vue&type=template&id=68a53f53&scoped=true"
import script from "./AntiEmailPage.vue?vue&type=script&lang=js"
export * from "./AntiEmailPage.vue?vue&type=script&lang=js"

import "./AntiEmailPage.vue?vue&type=style&index=0&id=68a53f53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a53f53"]])

export default __exports__